import VT from '@/store/types';
import jwtDecode from 'jwt-decode';
import ability from '@/_ability';

export default {
  [VT.SET_AUTH_INFO]: (state, data) => {
    state.roles = data.user.roles;
    state.user = data.user.user;
    const permissions = [];
    for (let i = 0; i < data.user.permissions.length; i++) {
      permissions.push(data.user.permissions[i].name);
    }
    for (let i = 0; i < data.user.roles.length; i++) {
      for (let j = 0; j < data.user.roles[i].permissions.length; j++) {
        if (!permissions.includes(data.user.roles[i].permissions[j].name)) {
          permissions.push(data.user.roles[i].permissions[j].name);
        }
      }
    }
    
    state.permissions = permissions;
    
    const abilities = [];
    
    for (let i = 0; i < state.permissions.length; i++) {
      const [subject, actions] = state.permissions[i].split('.');
      abilities.push({ subject: subject, actions: actions });
    }

    state.abilities = abilities;

    state.hasAuthInfo = true;
    ability.update(abilities);
  },
  [VT.SET_AUTH_TOKEN]: (state, token) => {
    state.token = token;
    state.exp = typeof state.token === 'string' && state.token.length > 0 ? jwtDecode(state.token).exp : 0;
  },
  [VT.SET_REFRESH_TOKEN]: (state, token) => {
    state.refreshToken = token;
    state.refreshTokenExp = typeof state.refreshToken === 'string'
    && state.refreshToken.length > 0 ? jwtDecode(state.refreshToken).exp : 0;
  },
};
